import React, { Component } from "react"
import { Route, Switch, Redirect } from "react-router-dom"
import Dashboard from "./dashboard"
import Report from "./report"
import DataManage from "./data_manage"
import RecycleBin from "./recycleBin"
import Statistics from "./statistics"
import DataStatistics from "./data_statistics"

export default class extends Component {
  render() {
    const { match } = this.props
    return (
      <Switch>
        <Route path={`${match.url}/overview`} component={Dashboard} />
        {/*长的 url 可能会被短的 path 匹配拦截到, 并进入当前匹配节点的 Component 中继续查询匹配*/}
        <Route path={`${match.url}/report`} component={Report} />
        <Route path={`${match.url}/data_manage`} component={DataManage} />
        <Route path={`${match.url}/data_statistics`} component={DataStatistics} />
        <Route path={`${match.url}/recycle_bin`} component={RecycleBin} />
        <Route path={`${match.url}/statistics`} component={Statistics} />
        <Redirect from='*' to={`${match.url}/overview`} />
      </Switch>
    )
  }
}




// WEBPACK FOOTER //
// ./src/app/pages/pgs/index.js